module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Appliquer les récompenses Carte de crédit',
        available: 'disponible',
        selectThree: 'Sélectionnez jusqu’à trois récompenses',
        creditCardReward: `<b>${vars[0]} $</b> en récompenses carte de crédit`,
        firstTimeDiscount: `<b>${vars[0]}</b> First Purchase`,
        expiry: `Exp. ${vars[0]}`,
        orderSubTotal: 'Sous-total de la commande',
        apply: 'Appliquer',
        applied: 'Appliqué',
        remove: 'Supprimer',
        ccMessage: '*Avec votre carte de crédit Sephora ou votre carte Visa Sephora. Des exceptions s’appliquent',
        clickHere: 'cliquez ici pour plus de détails',
        done: 'Terminé',
        maxRewardsReached: 'You\'ve reached the maximum number of credit card rewards per order.'
    };

    return resources[label];
};
